import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

import {
  passwordResetInitForm,
  passwordResetInitSchema,
} from './loginForm/constants';

import { useAppDispatch } from '../../../../../App/redux/store';
import Button from '../../../../../components/Assets/Button';
import TextInput from '../../../../../components/Forms/TextInput';
import { askforPasswordResetLinkThunk } from '../../../services/authThunks';
import styles from './loginContent.module.scss';
function PasswordResetInit() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: passwordResetInitForm,
    validationSchema: passwordResetInitSchema,
    onSubmit: (values) => {
      dispatch(askforPasswordResetLinkThunk({ ...values, navigate }));
    },
  });

  const { values, touched, errors } = formik;

  return (
    <form className={styles.askForPasswordResetLinkForm} noValidate>
      <TextInput
        className={styles.input}
        name="username"
        label="Email"
        type="email"
        value={values.username}
        handleChange={formik.handleChange}
        error={touched.username && Boolean(errors.username)}
        helperText={touched.username && errors.username ? errors.username : null}
      />
      <Button
        btnType="submit"
        btnContent="ENVOYER"
        primary
        handleClick={() => formik.handleSubmit()}
        className={styles.button}
      />
    </form>
  );
}

export default PasswordResetInit;
